import { CHANGE_PASSWORD, LOGIN, LOGIN_WITH_OTP, TENANT_ADMIN_LOGIN, TENANT_ADMIN_LOGIN_AS } from 'actions/authAction';
import { cookie } from 'utils/cookies/cookies';
import { toast } from 'react-toastify';

const initialState = {
  loginData: {},
  tenantAdminLoginData: {},
  error: '',
  isLoading: false,
};

// const location = JSON.parse(localStorage.getItem('pathname')) ? JSON.parse(localStorage.getItem('pathname')) : '/dashboard';

const authReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN.REQUEST:
    case CHANGE_PASSWORD.REQUEST:
    case LOGIN_WITH_OTP.REQUEST:
    case TENANT_ADMIN_LOGIN.REQUEST:
    case TENANT_ADMIN_LOGIN_AS.REQUEST: {
      return {
        ...state,
        error: '',
        isLoading: true,
      };
    }

    case LOGIN.SUCCESS: {
      const isDocoInstance = process.env.REACT_APP_IS_DOCO_INSTANCE === 'true';
      const restrictedRolesForNormalFlow = ['doco', 'saas_admin']; // Roles not allowed when isDocoInstance is false
      const allowedRolesForDocoInstance = ['doco', 'saas_admin']; // Roles allowed when isDocoInstance is true
    
    
      if (
        (isDocoInstance && !allowedRolesForDocoInstance.includes(payload.user.role)) || // Restrict roles for Doco instances
        (!isDocoInstance && restrictedRolesForNormalFlow.includes(payload.user.role))  // Restrict roles for normal flow
      ) {
        toast.error('Access denied. This role is not permitted in this instance.');
        // Clear token and exit early
        cookie.remove('token');
        setTimeout(() => {
          window.location.href = '/login';
        }, 1000);
    
        return {
          ...state,
          loginData: {},
          isLoading: false,
          error: 'Role not permitted',
        };
      }
    
      // Only proceed if login is permitted
      toast.success('Login successfully');
      cookie.set('token', payload.tokens.access.token);
      cookie.set('user-role', payload.user.role);
    
      if (
        payload.user.role === 'super_admin' ||
        payload.user.role === 'b2bclient' ||
        payload.user.role === 'fleet_owner' ||
        payload.user.role === 'gentari_custom_role' ||
        payload.user.role === 'finance'
      ) {
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 1000);
      } else if (
        payload.user.role === 'support_admin' ||
        payload.user.role === 'network_admin' ||
        payload.user.role === 'ZMT_admin' ||
        payload.user.role === 'finance_admin'
      ) {
        setTimeout(() => {
          window.location.href = '/tenantAdmin';
        }, 1000);
      } else {
        setTimeout(() => {
          window.location.href = '/stations';
        }, 1000);
      }
    
      return {
        ...state,
        loginData: payload.user,
        isLoading: false,
      };
    }
    case CHANGE_PASSWORD.SUCCESS: {
      return {
        ...state,
        loginData: payload,
        isLoading: false,
      };
    }
    case LOGIN_WITH_OTP.SUCCESS: {
      toast.success('Login successfully');
      cookie.set('token', payload.tokens.access.token);
      cookie.set('user-role', payload.user.role);
      setTimeout(() => {
        window.location.href = '/dashboard';
      }, 1000);
      return {
        ...state,
        loginData: payload.user,
        isLoading: false,
      };
    }

    case TENANT_ADMIN_LOGIN.SUCCESS: {
      toast.success('Tenant login successfully');
      cookie.set('token', payload.tokens.access.token);
      cookie.set('user-role', payload.user.role);
      if (payload.user.role === 'tenant_admin') {
        setTimeout(() => {
          window.location.href = '/stations';
        }, 1000);
      } else {
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 1000);
      }

      return {
        ...state,
        tenantAdminLoginData: payload.user,
        isLoading: false,
      };
    }

    case TENANT_ADMIN_LOGIN_AS.SUCCESS: {
      toast.success('Tenant login successfully');
      localStorage.setItem(`${payload.user.tenant}_token`, payload.tokens.access.token);
      localStorage.setItem(
        `${payload.user.tenant}_tenant_data`,
        JSON.stringify({
          tenantId: payload.user.tenant,
          role: payload.user.role,
        })
      );

      if (payload.user.role === 'support' || payload.user.role === 'admin' || payload.user.role === 'ZMT' || payload.user.role === 'finance') {
        setTimeout(() => {
          window.open('/dashboard?tenant=' + payload.user.tenant, '_blank');
        }, 1000);
      }

      return {
        ...state,
        tenantAdminLoginAsData: payload.user,
        isLoading: false,
      };
    }

    case LOGIN.FAIL:
    case CHANGE_PASSWORD.FAIL:
    case LOGIN_WITH_OTP.FAIL:
    case TENANT_ADMIN_LOGIN.FAIL:
    case TENANT_ADMIN_LOGIN_AS.FAIL: {
      //toast.error('Incorrect Phone or Password');
      return {
        ...state,
        error: payload.message,
        isLoading: false,
      };
    }

    default:
      return { ...state };
  }
};
export default authReducer;